import { Box, Typography, CircularProgress } from '@mui/material';
import React from 'react';
import Header from '../components/Header';

function LoadingPage() {
  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
      }}
    >
      <Header />
      <Box
        sx={{
          flex: 1,
          height: 'calc( 80vh - 73px )',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            gap: '24px',
            marginInline: '24px',
            width: '100%',
          }}
        >
          <Typography
            sx={{
              fontSize: '24px',
              fontWeight: '700',
              lineHeight: '28.845px',
              textAlign: 'center',
              color: '#33303C',
            }}
          >
            Uploading Image
          </Typography>
          <Box
            sx={{
              height: '196px',
              minHeight: '196px',
              boxShadow: '0px -1px 24px 0px rgba(0, 0, 0, 0.04)',
              borderRadius: '20px',
              background: '#fff',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '16px',
            }}
          >
            <div
              style={{
                height: '79px',
                width: '79px',
                marginInline: 'auto',
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  width: '30px',
                  height: '28px',
                  margin: 'auto',
                  top: '4px', // Move 4px down
                  left: '2px', // Move 2px to the right
                  right: 0,
                  bottom: 0,
                }}
              >
                {' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="31"
                  height="29"
                  viewBox="0 0 31 29"
                  fill="none"
                >
                  <path
                    d="M7.7328 4.32143C6.38422 4.32143 5.29101 5.37674 5.29101 6.67857C5.29101 7.9804 6.38422 9.03571 7.7328 9.03571C9.08139 9.03571 10.1746 7.9804 10.1746 6.67857C10.1746 5.37674 9.08088 4.32143 7.7328 4.32143ZM22.7447 0H3.2104C1.45791 0 0 1.40692 0 3.14286V18.8571C0 20.5931 1.45744 22 3.20994 22H22.7443C24.5426 22 26 20.5931 26 18.8571V3.14286C26.0005 1.40692 24.5863 0 22.7447 0ZM23.5587 18.5281L16.5996 9.39911C16.4724 9.17321 16.1824 9.03571 15.8721 9.03571C15.5611 9.03571 15.2708 9.17164 15.0984 9.39808L9.67556 16.4744L7.78876 14.2106C7.61372 14.0004 7.33428 13.8762 7.0374 13.8762C6.74022 13.8762 6.46104 14.0004 6.28553 14.2106L2.44378 18.8173C2.44378 18.8159 2.44378 18.8188 2.44378 18.8173L2.44175 3.14286C2.44175 2.70963 2.8069 2.35714 3.25568 2.35714H22.79C23.2388 2.35714 23.6039 2.70963 23.6039 3.14286V18.5281H23.5587Z"
                    fill="#33303C"
                  />
                  <path
                    d="M29.676 26.3184L24.1799 20.8223C25.3693 19.3662 26.0256 17.5328 26.0256 15.5312C26.0256 10.8186 22.2058 7 17.4943 7C12.7829 7 9 10.8198 9 15.5312C9 20.2427 12.8194 24.0625 17.4943 24.0625C19.4955 24.0625 21.3314 23.3689 22.7854 22.2152L28.2815 27.7113C28.5111 27.9057 28.7654 28 29.0156 28C29.2658 28 29.5193 27.9039 29.7117 27.7116C30.0943 27.3273 30.0943 26.7039 29.676 26.3184ZM10.9688 15.5312C10.9688 11.9129 13.9129 8.96875 17.5313 8.96875C21.1497 8.96875 24.0938 11.9129 24.0938 15.5312C24.0938 19.1496 21.1497 22.0938 17.5313 22.0938C13.9129 22.0938 10.9688 19.1488 10.9688 15.5312Z"
                    fill="#0179FF"
                  />
                  <path
                    d="M10.9688 15.5312C10.9688 11.9129 13.9129 8.96875 17.5313 8.96875C21.1497 8.96875 24.0938 11.9129 24.0938 15.5312C24.0938 19.1496 21.1497 22.0938 17.5313 22.0938C13.9129 22.0938 10.9688 19.1488 10.9688 15.5312Z"
                    fill="white"
                  />
                  <path
                    d="M29.676 26.3184L24.1799 20.8223C25.3693 19.3662 26.0256 17.5328 26.0256 15.5312C26.0256 10.8186 22.2058 7 17.4943 7C12.7829 7 9 10.8198 9 15.5312C9 20.2427 12.8194 24.0625 17.4943 24.0625C19.4955 24.0625 21.3314 23.3689 22.7854 22.2152L28.2815 27.7113C28.5111 27.9057 28.7654 28 29.0156 28C29.2658 28 29.5193 27.9039 29.7117 27.7116C30.0943 27.3273 30.0943 26.7039 29.676 26.3184ZM10.9688 15.5312C10.9688 11.9129 13.9129 8.96875 17.5313 8.96875C21.1497 8.96875 24.0938 11.9129 24.0938 15.5312C24.0938 19.1496 21.1497 22.0938 17.5313 22.0938C13.9129 22.0938 10.9688 19.1488 10.9688 15.5312Z"
                    stroke="#0179FF"
                    stroke-width="0.5"
                  />
                  <path
                    d="M10.9688 15.5312C10.9688 11.9129 13.9129 8.96875 17.5313 8.96875C21.1497 8.96875 24.0938 11.9129 24.0938 15.5312C24.0938 19.1496 21.1497 22.0938 17.5313 22.0938C13.9129 22.0938 10.9688 19.1488 10.9688 15.5312Z"
                    stroke="#0179FF"
                    stroke-width="0.5"
                  />
                </svg>
              </div>

              <CircularProgress
                // variant={'determinate'}
                // value={progress}
                size="79px"
                sx={{ marginInline: 'auto' }}
              />
            </div>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: '400',
                lineHeight: '24.87px',
                textAlign: 'center',
                color: '#000',
              }}
            >
              Checking your image...
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LoadingPage;
